import { Stack } from 'expo-router';
import React from 'react';

import SproutQAHistoryPage from '../../../llm-service/sprout/SproutQAHistoryPage';

export default function SproutQAHistoryRoute() {
    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Simulation History',
                }}
            />
            <SproutQAHistoryPage />
        </>
    );
}
